import { render } from "./GoodiesView.vue?vue&type=template&id=49f1a898&scoped=true"
import script from "./GoodiesView.vue?vue&type=script&lang=js"
export * from "./GoodiesView.vue?vue&type=script&lang=js"

import "./GoodiesView.vue?vue&type=style&index=0&id=49f1a898&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f1a898"]])

export default __exports__